import { render, staticRenderFns } from "./DashboardLayoutAuth.vue?vue&type=template&id=666b68d6"
import script from "./DashboardLayoutAuth.vue?vue&type=script&lang=js"
export * from "./DashboardLayoutAuth.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayoutAuth.vue?vue&type=style&index=0&id=666b68d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports